// src/components/HeroSection.jsx
import React, { useState } from "react";
import { Container, Row, Button, Carousel } from "react-bootstrap";
import { motion } from "framer-motion";
import "./HeroSection.css";

// Import images (replace with Strat Edge project-related images if available)
import hero1 from "../assets/banner-12.png";
import hero2 from "../assets/banner-13.png";
import hero3 from "../assets/banner-33.png";
import client1 from "../assets/logo-11.png";
import client2 from "../assets/logo-2.png";
import client3 from "../assets/logo-441.png";
import client4 from "../assets/logo-3.jpeg";

const HeroSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Animation settings
  const slideInLeft = {
    hidden: { opacity: 0, x: -80 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.7, ease: "easeOut" },
    },
  };

  // ✅ Reusable CTA + Clients block
  const CTASection = () => (
    <div className="hero-bottom d-flex align-items-center mt-4">
      <Button variant="danger" className="fancy-btn me-3">
        EXPLORE SERVICES <span className="arrow">→</span>
      </Button>

      <div className="d-flex align-items-center">
        <img src={client1} alt="client 1" className="client-img" />
      <img src={client2} alt="client 2" className="client-img" />
      <img src={client3} alt="client 3" className="client-img" />
      <img src={client4} alt="client 4" className="client-img" />
        <span className="ms-2">Trusted by Global Clients</span>
      </div>
    </div>
  );

  return (
    <div className="hero-section">
      <Carousel
        fade
        interval={4000} // ✅ Auto slide every 4s
        controls={false} // ✅ Hide arrows
        indicators={false} // ✅ Remove dots
        className="custom-carousel"
        activeIndex={activeIndex}
        onSelect={(selectedIndex) => setActiveIndex(selectedIndex)} // track active slide
      >
        {/* Slide 1 */}
        <Carousel.Item>
          <div
            className="hero-slide"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url(${hero1})`,
            }}
          >
            <Container>
              <Row className="align-items-center">
                <motion.div
                  className="col-md-7 text-white hero-text"
                  variants={slideInLeft}
                  initial="hidden"
                  animate={activeIndex === 0 ? "visible" : "hidden"}
                  key={`slide1-${activeIndex}`}
                >
                  <p className="tagline">STRATEGIC PROJECT MANAGEMENT</p>
                  <h1 className="fw-bold">
                    Driving Projects <br /> From Vision to Reality
                  </h1>
                  <p className="description">
                    Strat Edge delivers end-to-end project management solutions
                    — from planning and strategy to seamless execution — helping
                    organizations achieve goals on time and within budget.
                  </p>
                  <CTASection />
                </motion.div>
              </Row>
            </Container>
          </div>
        </Carousel.Item>

        {/* Slide 2 */}
        <Carousel.Item>
          <div
            className="hero-slide"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url(${hero2})`,
            }}
          >
            <Container>
              <Row className="align-items-center">
                <motion.div
                  className="col-md-7 text-white hero-text"
                  variants={slideInLeft}
                  initial="hidden"
                  animate={activeIndex === 1 ? "visible" : "hidden"}
                  key={`slide2-${activeIndex}`}
                >
                  <p className="tagline">CONSULTING & STRATEGY</p>
                  <h1 className="fw-bold">
                    Smart Solutions <br /> For Complex Projects
                  </h1>
                  <p className="description">
                    Our expert consultants analyze challenges, identify risks,
                    and provide tailored strategies that empower businesses to
                    deliver successful, scalable, and sustainable projects.
                  </p>
                  <CTASection />
                </motion.div>
              </Row>
            </Container>
          </div>
        </Carousel.Item>

        {/* Slide 3 */}
        <Carousel.Item>
          <div
            className="hero-slide"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url(${hero3})`,
            }}
          >
            <Container>
              <Row className="align-items-center">
                <motion.div
                  className="col-md-7 text-white hero-text"
                  variants={slideInLeft}
                  initial="hidden"
                  animate={activeIndex === 2 ? "visible" : "hidden"}
                  key={`slide3-${activeIndex}`}
                >
                  <p className="tagline">EXECUTION & DELIVERY</p>
                  <h1 className="fw-bold">
                    On-Time, On-Budget <br /> Project Execution
                  </h1>
                  <p className="description">
                    With proven methodologies, advanced tools, and a client-first
                    approach, Strat Edge ensures project milestones are met with
                    efficiency, quality, and precision.
                  </p>
                  <CTASection />
                </motion.div>
              </Row>
            </Container>
          </div>
        </Carousel.Item>
      </Carousel>

      {/* Social Media Sidebar */}
      <div className="social-sidebar">
        <a href="https://www.facebook.com/profile.php?id=61581231150639&mibextid=wwXIfr&rdid=mjSbhOGlm2cFCWts&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BCMNEdbV3%2F%3Fmibextid%3DwwXIfr#"><i className="bi bi-facebook"></i></a>
        <a href="https://x.com/stratedgepm?s=11&t=grt9FJqqZHF7j9EPMUViXg"><i className="bi bi-twitter"></i></a>
        <a href="https://www.linkedin.com/company/strat-edge-project-management-services/"><i className="bi bi-linkedin"></i></a>
        <a href="https://www.instagram.com/stratedge_projectmanagement?igsh=MXU1bGRuaDVjZnVjMQ%3D%3D&utm_source=qr"><i className="bi bi-instagram"></i>
</a>
        <span className="vertical-text">FOLLOW US</span>
      </div>
    </div>
  );
};

export default HeroSection;
